import { StorageE } from 'declarations/enums/storage';

import { getDecodedToken } from './jwtToken';

export const getUserPlaceholderName = (firstName?: string, lastName?: string): string => {
  const first = firstName?.[0] ?? '';
  const last = lastName?.[0] ?? '';

  return (first + last).toUpperCase();
};

export function getIdToken(): string | null {
  return localStorage.getItem(StorageE.IdToken);
}

export function isAgentUser(): boolean {
  const idToken = getIdToken();
  const decodedToken = getDecodedToken(idToken);
  return !!decodedToken?.['custom:IsAgent'];
}

export function getCurrentUserId(): string | null {
  const idToken = getIdToken();
  const decodedToken = getDecodedToken(idToken);

  if (!decodedToken) {
    return null;
  }

  const isAgent = !!decodedToken['custom:IsAgent'];
  const userIdKey = isAgent ? 'custom:agent_user_id' : 'custom:admin_user_id';

  const userId = decodedToken[userIdKey];
  return typeof userId === 'string' ? userId : null;
}
